import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-1 whitespace-pre-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "mr-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lines, (line, lineIndex) => {
      return (_openBlock(), _createElementBlock("p", { key: lineIndex }, [
        (line.isBullet)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "•"))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.tokens, (token, tokenIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: tokenIndex }, [
            (token.type === 'strong')
              ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(token.content), 1 /* TEXT */))
              : (token.type === 'link')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: token.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "text-[#48DDC3] underline hover:text-[#3bc4ab]"
                  }, _toDisplayString(token.content), 9 /* TEXT, PROPS */, _hoisted_4))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(token.content), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}